export const categoryType = ['SERVICE', 'QUERY'];
export const Gender = ['Male', 'Female', 'Transgender'];
export const PROMPT_BEFORE_IDLE_MS = 2000;  //10 s
export const serviceType = ['Service', 'Training'];
export const MAX_DOCUMENT_TAGS_INLINE = 2;
export const documentFieldName = 'documents';

export const plans = [
    {
        id: "Basic",
        name: "Standard",
        basePrice: 0,
        variant: "basic",
        description: "Perfect for small schools just getting started.",
        features: ["Up to 50 Students", "2 Instructors", "Basic Scheduling", "Email Support", "Student Enrollment", "Batch Management"],
        limit: 50,
    },
    {
        id: "Professional",
        name: "Professional",
        basePrice: 99,
        description: "Advanced features for growing driving schools.",
        features: ["Up to 500 Students", "10 Instructors", "Vehicle Management", "Priority Support", "Mobile App Access", "Expense Tracking", "Query Management"],
        limit: 500,
    },
    {
        id: "Enterprise",
        name: "Enterprise",
        basePrice: 199,
        description: "Custom solutions for large multi-location schools.",
        features: ["Unlimited Students", "Unlimited Instructors", "Mobile App Access", "Field Officer Support", "Advanced Analytics", "All Professional Features"],
        limit: 1000,
    }
];

export const TERMS_AND_CONDITIONS = `
<h3>Terms & Conditions for Driving School Registration</h3>
<p><strong>Last Updated:</strong> March 2026</p>
<h4>1. Acceptance of Terms</h4>
<p>By registering your driving school on this platform, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not register.</p>
<h4>2. Eligibility</h4>
<p>You must have the legal authority to register and operate a driving school in your jurisdiction. You confirm that all information provided during registration is accurate and complete.</p>
<h4>3. Account Responsibilities</h4>
<p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.</p>
<h4>4. Service Usage</h4>
<p>Our platform provides tools to manage students, instructors, vehicles, schedules, and payments. You agree to use these services in compliance with all applicable laws and regulations.</p>
<h4>5. Payment & Billing</h4>
<p>You agree to pay all fees associated with your subscription plan. Subscription fees are billed in advance on a monthly or yearly basis as selected during registration. You have the authority to accept payments on behalf of your driving school.</p>
<h4>6. Data Privacy</h4>
<p>We take your privacy seriously. All personal and business data you provide will be handled in accordance with our Privacy Policy. You retain ownership of your data and can export or delete it at any time.</p>
<h4>7. Termination</h4>
<p>Either party may terminate this agreement at any time. Upon termination, you will retain access to your data for a grace period of 30 days, after which your account and data may be permanently deleted.</p>
<h4>8. Limitation of Liability</h4>
<p>Our platform is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
<h4>9. Changes to Terms</h4>
<p>We reserve the right to modify these terms at any time. We will notify you of significant changes via email. Continued use of the platform after changes constitutes acceptance of the modified terms.</p>
<h4>10. Contact</h4>
<p>If you have questions about these terms, please contact our support team.</p>
`;
